import { Box, SvgIcon, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as PersonsIcon } from "../../../common/icons/persons.svg";

const UsersEmptyState = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ padding: "1rem 1rem 0 1rem" }}>
      <SvgIcon
        sx={{ width: "48px", height: "45px" }}
        component={PersonsIcon}
        viewBox="0 0 48 45"
      />
      <Typography marginTop="1rem">
        {t("customers:usersNS:emptyStateLabel")}
      </Typography>
    </Box>
  );
};

export default UsersEmptyState;
